import React from 'react';
import './../App.css';
import './TablePageSZ.css';
import { collectLoginClientInfo } from "../helpers/browser-info";

// import Weel from './weel/Weel';
import RouletteTable from './table/TableSZ';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { GiDiamonds } from 'react-icons/gi'; 

import firstRow from './table/rows/FirstRow.json';
import firstBorder from './table/rows/FirstBorder.json';
import secondRow from './table/rows/SecondRow.json';
import secondBorder from './table/rows/SecondBorder.json';
import thirdRow from './table/rows/ThirdRow.json';
import thirdBorder from './table/rows/ThirdBorder.json';
import fourthRow from './table/rows/FourthRow.json';
import fifthRow from './table/rows/FifthRow.json';
import columnLeft from './table/rows/ColumnLeft.json';
import columnRight from './table/rows/ColumnRight.json';
import { io } from 'socket.io-client';
// import basketBetIcon from './../assets/pngwing.com.png';

import iconOk from './../images/ok-btn.svg';
import iconClose from './../images/icon-close.svg';
import iconReplay from './../images/icon-home.svg';
import iconReceipt from './../images/receipt.svg';
import iconReprint from './../images/reprint.svg';
import iconRepeatBet from './../images/icon-repeat-bet.svg';
import iconVoid from './../images/void.svg';

import homeIcon from '../images/icons/home-icon.svg';
import createIcon from '../images/icons/create-icon.svg';
import validateIcon from '../images/icons/validate-icon.svg';
import historyIcon from '../images/icons/history-icon.svg';
import shiftIcon from '../images/reprint.svg';


import jsPDF from "jspdf";
import "jspdf-autotable";
import bwipjs from 'bwip-js'; 
import withNavigation from './withNavigation'; // Import the wrapper
import axios from 'axios';
import { API_URL, SOCKET_URL } from './environment';


import ReactDOM from "react-dom";
import { _16To10 } from "simple-base-converter";
 
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; 
import betmap from './betmap_OLD.json';



class App extends React.Component {

  

 

  state = {
    num: "", //winning number
    arr: [], //array of bets
    betsLog: [],
    betsLogL: [],
    betsLogR: [],
    count: 0, //spins count
    wins: 0, //wins count
    chip: 10, //chip value
    coins: 100000, //coins count
    losses: 0, //losses count
    timer: 0,
    spinning: false, //the wheel is spinning?
    agentID: "",
    gameID: "",
    bettingShopID: "",
    gameSpinNumber: "",
    betDenomination: 0,
    selectedBets: {},   // Stores placed bets
    ...this.state, // Include your existing state variables
    betsTotal: 0,
    // betsInfoTxt: 'ON',
    infoText: 'BETS ON',
    message: "Put your bets and spin the wheel!", //message
    extArr: [], //little trick: pushing number here if user win, so if it's empty, user loose
    hot1: 0, hot2: 0, hot3: 0, hot4: 0, hot5: 0,
    cold1: 0, cold2: 0, cold3: 0, cold4: 0, cold5: 0,
    isTicketPopupVisible: false,
    isVoidTicketPopupVisible: false,
    ticketIdInput: "",
    lastScanned: "",
    isMenuOpen: true, // Menu open/close state
    activeHistoryBlock: 5,

    //my JSON rows
    firstRow, firstBorder, secondRow, secondBorder, thirdRow, thirdBorder, fourthRow, fifthRow, columnLeft, columnRight,
    betsMap: {
      'BLACK': undefined,
      'COLUMN1': undefined,
      'COLUMN2': undefined,
      'COLUMN3': undefined,
      'CORNER1': undefined,
      'CORNER2': undefined,
      'CORNER3': undefined,
      'CORNER4': undefined,
      'CORNER5': undefined,
      'CORNER6': undefined,
      'CORNER7': undefined,
      'CORNER8': undefined,
      'CORNER9': undefined,
      'CORNER10': undefined,
      'CORNER11': undefined,
      'CORNER12': undefined,
      'CORNER13': undefined,
      'CORNER14': undefined,
      'CORNER15': undefined,
      'CORNER16': undefined,
      'CORNER17': undefined,
      'CORNER18': undefined,
      'CORNER19': undefined,
      'CORNER20': undefined,
      'CORNER21': undefined,
      'CORNER22': undefined,
      'DOZEN1': undefined,
      'DOZEN2': undefined,
      'DOZEN3': undefined,
      'ZERO_SPIEL': undefined,
      'ORPHELINS': undefined,
      'VOISINS': undefined,
      'EVEN': undefined,
      'FIRSTFOUR': undefined,
      'HIGH': undefined,
      'LOW': undefined,
      'ODD': undefined,
      'RED': undefined,
      'SINGLE1': undefined,
      'SINGLE2': undefined,
      'SINGLE3': undefined,
      'SINGLE4': undefined,
      'SINGLE5': undefined,
      'SINGLE6': undefined,
      'SINGLE7': undefined,
      'SINGLE8': undefined,
      'SINGLE9': undefined,
      'SINGLE10': undefined,
      'SINGLE11': undefined,
      'SINGLE12': undefined,
      'SINGLE13': undefined,
      'SINGLE14': undefined,
      'SINGLE15': undefined,
      'SINGLE16': undefined,
      'SINGLE17': undefined,
      'SINGLE18': undefined,
      'SINGLE19': undefined,
      'SINGLE20': undefined,
      'SINGLE21': undefined,
      'SINGLE22': undefined,
      'SINGLE23': undefined,
      'SINGLE24': undefined,
      'SINGLE25': undefined,
      'SINGLE26': undefined,
      'SINGLE27': undefined,
      'SINGLE28': undefined,
      'SINGLE29': undefined,
      'SINGLE30': undefined,
      'SINGLE31': undefined,
      'SINGLE32': undefined,
      'SINGLE33': undefined,
      'SINGLE34': undefined,
      'SINGLE35': undefined,
      'SINGLE36': undefined,
      'SINGLE37': undefined,
      'SIXLINE1': undefined,
      'SIXLINE2': undefined,
      'SIXLINE3': undefined,
      'SIXLINE4': undefined,
      'SIXLINE5': undefined,
      'SIXLINE6': undefined,
      'SIXLINE7': undefined,
      'SIXLINE8': undefined,
      'SIXLINE9': undefined,
      'SIXLINE10': undefined,
      'SIXLINE11': undefined,
      'SPLIT1': undefined,
      'SPLIT2': undefined,
      'SPLIT3': undefined,
      'SPLIT4': undefined,
      'SPLIT5': undefined,
      'SPLIT6': undefined,
      'SPLIT7': undefined,
      'SPLIT8': undefined,
      'SPLIT9': undefined,
      'SPLIT10': undefined,
      'SPLIT11': undefined,
      'SPLIT12': undefined,
      'SPLIT13': undefined,
      'SPLIT14': undefined,
      'SPLIT15': undefined,
      'SPLIT16': undefined,
      'SPLIT17': undefined,
      'SPLIT18': undefined,
      'SPLIT19': undefined,
      'SPLIT20': undefined,
      'SPLIT21': undefined,
      'SPLIT22': undefined,
      'SPLIT23': undefined,
      'SPLIT24': undefined,
      'SPLIT25': undefined,
      'SPLIT26': undefined,
      'SPLIT27': undefined,
      'SPLIT28': undefined,
      'SPLIT29': undefined,
      'SPLIT30': undefined,
      'SPLIT31': undefined,
      'SPLIT32': undefined,
      'SPLIT33': undefined,
      'SPLIT34': undefined,
      'SPLIT35': undefined,
      'SPLIT36': undefined,
      'SPLIT37': undefined,
      'SPLIT38': undefined,
      'SPLIT39': undefined,
      'SPLIT40': undefined,
      'SPLIT41': undefined,
      'SPLIT42': undefined,
      'SPLIT43': undefined,
      'SPLIT44': undefined,
      'SPLIT45': undefined,
      'SPLIT46': undefined,
      'SPLIT47': undefined,
      'SPLIT48': undefined,
      'SPLIT49': undefined,
      'SPLIT50': undefined,
      'SPLIT51': undefined,
      'SPLIT52': undefined,
      'SPLIT53': undefined,
      'SPLIT54': undefined,
      'SPLIT55': undefined,
      'SPLIT56': undefined,
      'SPLIT57': undefined,
      'SPLIT58': undefined,
      'SPLIT59': undefined,
      'SPLIT60': undefined,
      'STREET1': undefined,
      'STREET2': undefined,
      'STREET3': undefined,
      'STREET4': undefined,
      'STREET5': undefined,
      'STREET6': undefined,
      'STREET7': undefined,
      'STREET8': undefined,
      'STREET9': undefined,
      'STREET10': undefined,
      'STREET11': undefined,
      'STREET12': undefined,
      'STREET13': undefined,
      'STREET14': undefined,
    },
    isUndo: false,

    // ...this.state,
    basketBet: false, // Track whether a basket bet is active
    sections: [
      {
        id: "default",
        numbers: ["0", "00"],
      },
      {
        id: "SEQ1",
        label: "1 - 9",
        numbers: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
      },
      {
        id: "SEQ2",
        label: "10 - 18",
        numbers: ["10", "11", "12", "13", "14", "15", "16", "17", "18"],
      },
      {
        id: "SEQ3",
        label: "19 - 27",
        numbers: ["19", "20", "21", "22", "23", "24", "25", "26", "27"],
      },
      {
        id: "SEQ4",
        label: "28 - 36",
        numbers: ["28", "29", "30", "31", "32", "33", "34", "35", "36"],
      },
      {
        id: "special",
        numbers: [
          { id: "SEC1", label: "SILVER", className: "roulette-grid__silver" },
          { id: "SEC2", label: "GOLD", className: "roulette-grid__gold" },
          { id: "SEC3", label: "BRONZE", className: "roulette-grid__bronze" },
          { id: "SEC4", label: "RED", className: "roulette-grid__red" },
          { id: "PRI1", label: "GREEN", className: "roulette-grid__green" },
          { id: "PRI2", label: "BLUE", className: "roulette-grid__blue" },
          { id: "EVEN", label: "EVEN" },
          { id: "ODD", label: "ODD" },
        ],
      },
    ],
    bgTimer: 0,
  }


  //declaring here all the combinations, easier this way
  twoByOneFirst = ["3", "6", "2", "12", "15", "18", "21", "24", "27", "30", "33", "36"];
  twoByOneSecond = ["2", "5", "8", "11", "14", "17", "20", "23", "26", "29", "32", "35"];
  twoByOneThird = ["1", "4", "7", "10", "13", "16", "19", "22", "25", "28", "31", "34"];
  firstTwelves = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
  secondTwelves = ["13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24"];
  thirdTwelves = ["25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36"];
  oneToEighteen = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18"];
  nineteenToThirtySix = ["19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36"];
  black = ["2", "4", "6", "8", "10", "11", "13", "15", "17", "20", "22", "24", "26", "28", "29", "31", "33", "35"];
  red = ['1', '3', '5', '7', '9', '12', '14', '16', '18', '19', '21', '23', '25', '27', '30', '32', '34', '36'];
  even = ["2", "4", "6", "8", "10", "12", "14", "16", "18", "20", "22", "24", "26", "28", "30", "32", "34", "36"];
  odd = ['1', '3', '5', '7', '9', '11', '13', '15', '17', '19', '21', '23', '25', '27', '29', '31', '33', '35'];

  IP_SERVICE = 'https://api64.ipify.org/?format=json';

  navigateHomePage = false;
  socketServer;
  tableRef;
  lastCreateTimeRef;
  futureBetIndexRef;
  betMultiplierRef;
  futureGamesRef;
  isRepeatedBetRef;

  buffer = '';
  timeout = null;

  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    this.lastCreateTimeRef = React.createRef();
    this.lastCreateTimeRef.current = 0;
    this.futureBetIndexRef = React.createRef();
    this.futureBetIndexRef.current = 0;
    this.betMultiplierRef = React.createRef();
    this.betMultiplierRef.current = 1;
    this.futureGamesRef = React.createRef();
    this.futureGamesRef.current = [];
    this.isRepeatedBetRef = React.createRef();
    this.isRepeatedBetRef.current = false;

    this.buffer = '';
    this.timeout = null;    
  }

  // Load helper to set logs & hot/cold
  loadHistoryAndHotCold(data) {

    const currentTimer = this.state.timer;
    if (currentTimer >= 0 && currentTimer < 17) {
      return;
    }

    if (!data.history) {
      return;
    }
    const historyArr = data.history.split(',');
    const historySpinArr = data.spinNumberHistory.split(',');
    const betsLogArrL = [];
    const betsLogArrR = [];

    for (let count = 0; count < historyArr.length; count++) {
      // if (count < 10) {
      //   betsLogArrL.push({
      //     spinId: historySpinArr[count],
      //     number: historyArr[count],
      //   });
      // }
      if (count < 8) {
        betsLogArrL.push({
          spinId: historySpinArr[count],
          number: historyArr[count],
        });
      } else {
        betsLogArrR.push({
          spinId: historySpinArr[count],
          number: historyArr[count],
        });
      }
    }

    const hotNumbers = data.hot.split(',');
    const coldNumbers = data.cold.split(',');

    // const logObj = {
    //   isLoaded: true,
    //   betsLogL: betsLogArrL,
    //   betsLogR: betsLogArrR,
    //   hot1: hotNumbers[0],
    //   hot2: hotNumbers[1],
    //   hot3: hotNumbers[2],
    //   hot4: hotNumbers[3],
    //   hot5: hotNumbers[4],
    //   cold1: coldNumbers[0],
    //   cold2: coldNumbers[1],
    //   cold3: coldNumbers[2],
    //   cold4: coldNumbers[3],
    //   cold5: coldNumbers[4],
    // };
    // console.log('logObj', logObj);

    this.setState({
      isLoaded: true,
      betsLogL: betsLogArrL,
      betsLogR: betsLogArrR,
      hot1: hotNumbers[0],
      hot2: hotNumbers[1],
      hot3: hotNumbers[2],
      hot4: hotNumbers[3],
      hot5: hotNumbers[4],
      cold1: coldNumbers[0],
      cold2: coldNumbers[1],
      cold3: coldNumbers[2],
      cold4: coldNumbers[3],
      cold5: coldNumbers[4],
    });
  }  

  componentDidMount() {

    //grab here user data from database and set state with that data
    this.socketServer = io(SOCKET_URL);

    this.socketServer.open();
    // this.socketServer.on('stage-change', (data) => {
    //   var gameData = JSON.parse(data) as GameData
    //   console.log('CONNECTION', data);
    //   this.setGameData(gameData)      
    // });
    this.socketServer.on('connect', (socket) => {
      console.log('connect');
      this.socketServer.emit('authentication', {username: 'sadmin', password: 'Admin776!'});

    });

    this.socketServer.on('authentication_response', (data) => {
      console.log('authentication_response', data);
      this.socketServer.emit('join_room', {room: 'agent'});
    });

    this.socketServer.on('unauthorized', (data) => {
      console.log('unauthorized', data);
    });

    this.socketServer.on('join_room_response', (data) => {
      console.log('join_room_response', data);
      const storedUserId = localStorage.getItem("sun_userId") || '';
      const storedShopId = localStorage.getItem('sun_bettingShopId') || '';
      this.setState({agentID: storedUserId, bettingShopID: storedShopId});

      // this.setState({agentID: data.agentID, bettingShopID: data.bettingShopID});
    });

 

    this.socketServer.on('game', (data) => {
      // console.log('GAME', data);
      this.loadHistoryAndHotCold(data);
      const timerSec = data.timer;
      const BEFORE_SPIN_TIME = 165;
      let currentTimer = 0;
      let infoText;
      if (timerSec < BEFORE_SPIN_TIME) {
        currentTimer = BEFORE_SPIN_TIME - timerSec;
        infoText = 'BETS ON';
        // this.tableRef.current.updateBetsInfoTxt('ON');
       } else {
        currentTimer = 0;
        infoText = 'BETS OFF';
        // this.tableRef.current.updateBetsInfoTxt('OFF');
      }
      const futureGames = (data && data.futureGames) || [];
      this.futureGamesRef.current = futureGames;
      this.setState({timer: currentTimer, gameID: data.gameID, gameSpinNumber: data.gameSpinNumber, infoText});
    });

    this.socketServer.on('create_ticket_response', async (data) => {
      // console.log('create_ticket_response', data);
      // console.log('data.ticketObj', JSON.stringify(data.ticketObj));

      if (data.success) {
        this.generatePDF(data.ticketObj, data.bettingShop);
        if (this.betMultiplierRef.current > 1) {

          setTimeout(() => {
            this.createTicket(true, true);
          }, 200);
        }

        this.notify('Ticket created successfully and sent to printer', 'success');

        const userId = localStorage.getItem("sun_userId");
        // GET ip address
        const ipRes = await axios.get(this.IP_SERVICE);
        const curIp = (ipRes && ipRes.data && ipRes.data.ip) || 0;

        const metadata = await collectLoginClientInfo({
          includeGeolocation: true,
          geolocationOptions: {
            enableHighAccuracy: false,
            timeout: 2000,
            maximumAge: 300000,
          },
        });

        const isRepeatedBet = this.isRepeatedBetRef.current;

        try {
          axios.post(`${API_URL}/logaction`, {
            action: 'create_ticket',
            user: userId,
            role: 'CASHIER',
            ticketId: data.ticketObj?._id,        
            gameId: data.ticketObj?.gameId,
            bettingShopId: this.state.bettingShopID,
            ipAddress: curIp,
            metadata,
            isRepeatedBet,
          });
        } catch (e) {
          console.log(e);
        }

      } else {
        this.onClearTable();
        this.notify('Issue creating ticket', 'error');
      }
      // console.log(data.ticketObj, data.bettingShop);
    });

    window.addEventListener('keydown', this.handleKeydown);
  }

  componentWillUnmount() {
    this.socketServer.close();
    window.removeEventListener('keydown', this.handleKeydown);
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  handleKeydown = (event) => {
    if (event.key === "Enter") {
      // Save scanned barcode to state
      this.setState({ 
        ticketIdInput: this.buffer,
        lastScanned: this.buffer,
      }, () => {
        const isVoid = this.state.isVoidTicketPopupVisible;
        if (isVoid) {
          this.handleVoidTicket();
        } else {
          this.handleReadTicket(); // <-- auto-validate after scan
        }
      });

      // Clear buffer
      this.buffer = '';
    } else if (event.key.length === 1) {
      // Append character
      this.buffer += event.key;

      // Reset buffer if idle for 300ms
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.buffer = '';
      }, 300);
    }
  };

  cancelTicket = () => {
    this.props.navigate('/dashboard');
  }

  repeatBet = async() => {
    // call to get last ticket for this betting shop
    // parse response and convert to a bet

    const lastBetReds = await axios.get(`${API_URL}/lastticketbetshop`, {
      params: {bettingShopId: this.state.bettingShopID},
    });

    const lastBet = (lastBetReds?.data?.length && lastBetReds.data[0]) || {};
    let lastBetsMap;
    const hasOrigBetsMap = lastBet && lastBet.placedBets;

    if (hasOrigBetsMap) {
      lastBetsMap = lastBet?.placedBets || {};
    } else {
      lastBetsMap = lastBet?.bets || {};
    }

    const newBetsAsInt = Object.fromEntries(
      Object.entries(lastBetsMap).map(([key, value]) => [key, parseInt(value, 10)])
    );
    let updatedBetsMap = { ...newBetsAsInt };

    const aggregateMultiSideBets = (betsMap) => {

      const MULTI_SIDE_BETS = ['REDSPLIT','BLACKSPLIT','ZEROSPIEL','SNAKE','ORPHELINS','TIERS','VOISINS'];

      // Create a fresh object to avoid mutating the input directly
      const result = { ...betsMap };

      // For each prefix in MULTI_SIDE_BETS
      for (const prefix of MULTI_SIDE_BETS) {
        let total = 0;
        const keysToRemove = [];

        // Scan all keys in current result
        for (const key in result) {
          if (key.startsWith(prefix + '_') || key === prefix) {
            // If it's already the aggregated key → skip (in case it was there)
            if (key === prefix) continue;

            // It's a detailed key like ORPHELINS_17_20
            const value = Number(result[key]);
            if (!isNaN(value)) {
              total += value;
            }
            keysToRemove.push(key);
          }
        }

        // Remove the detailed keys
        for (const key of keysToRemove) {
          delete result[key];
        }

        // If we found any values → add the aggregated entry
        if (total > 0) {
          result[prefix] = total; // keep as string like original values
        }
      }

      return result;
    };

    if (!hasOrigBetsMap) {
      updatedBetsMap = aggregateMultiSideBets(updatedBetsMap);
    }

    const betsTotal = this.calculateBetsTotal(updatedBetsMap);
    this.tableRef.current.setState({betsMap: updatedBetsMap, betsTotal});

    this.setState({
      betsMap: updatedBetsMap,
      betsTotal,
    });

    const userId = localStorage.getItem("sun_userId");
    // GET ip address
    const ipRes = await axios.get(this.IP_SERVICE);
    const curIp = (ipRes && ipRes.data && ipRes.data.ip) || 0;

    const metadata = await collectLoginClientInfo({
      includeGeolocation: true,
      geolocationOptions: {
        enableHighAccuracy: false,
        timeout: 2000,
        maximumAge: 300000,
      },
    });

    try {
      axios.post(`${API_URL}/logaction`, {
        action: 'repeat_bet',
        user: userId,
        role: 'CASHIER',
        gameId: this.state.gameID,
        bettingShopId: this.state.bettingShopID,
        ticketId: lastBet?._id,
        metadata,
        ipAddress: curIp,
      });
    } catch (e) {
      console.log(e);
    }
  }

  reprintTicket = async() => {
    // call to get last ticket for this betting shop
    // parse response and convert to a bet

    const lastBetReds = await axios.get(`${API_URL}/lastticketbetshop`, {
      params: {bettingShopId: this.state.bettingShopID},
    });
    const ticketData = (lastBetReds?.data?.length && lastBetReds.data[0]) || {};
    if (lastBetReds?.data?.length) {
      this.generatePDF(ticketData, ticketData.bettingShopId?.name);
      this.notify('Ticket successfully sent to printer', 'success');
      const userId = localStorage.getItem("sun_userId");

      // GET ip address
      const ipRes = await axios.get(this.IP_SERVICE);
      const curIp = (ipRes && ipRes.data && ipRes.data.ip) || 0;

      const metadata = await collectLoginClientInfo({
        includeGeolocation: true,
        geolocationOptions: {
          enableHighAccuracy: false,
          timeout: 2000,
          maximumAge: 300000,
        },
      });

      await axios.post(`${API_URL}/logaction`, {
        action: 'reprint_ticket',
        gameId: this.state.gameID,
        ticketId: ticketData._id,
        role: 'CASHIER',
        user: userId,
        bettingShopId: this.state.bettingShopID,
        ipAddress: curIp,
        metadata,
      });
    } else {
      this.notify('Issue reprinting last ticket', 'error');
    }
  }

  clearBetsMap = () => {
    this.setState({
      betsMap: {
        'BLACK': undefined,
        'COLUMN1': undefined,
        'COLUMN2': undefined,
        'COLUMN3': undefined,
        'CORNER1': undefined,
        'CORNER2': undefined,
        'CORNER3': undefined,
        'CORNER4': undefined,
        'CORNER5': undefined,
        'CORNER6': undefined,
        'CORNER7': undefined,
        'CORNER8': undefined,
        'CORNER9': undefined,
        'CORNER10': undefined,
        'CORNER11': undefined,
        'CORNER12': undefined,
        'CORNER13': undefined,
        'CORNER14': undefined,
        'CORNER15': undefined,
        'CORNER16': undefined,
        'CORNER17': undefined,
        'CORNER18': undefined,
        'CORNER19': undefined,
        'CORNER20': undefined,
        'CORNER21': undefined,
        'CORNER22': undefined,
        'DOZEN1': undefined,
        'DOZEN2': undefined,
        'DOZEN3': undefined,
        'ZERO_SPIEL': undefined,
        'ORPHELINS': undefined,
        'VOISINS': undefined,
        'EVEN': undefined,
        'FIRSTFOUR': undefined,
        'HIGH': undefined,
        'LOW': undefined,
        'ODD': undefined,
        'RED': undefined,
        'SINGLE1': undefined,
        'SINGLE2': undefined,
        'SINGLE3': undefined,
        'SINGLE4': undefined,
        'SINGLE5': undefined,
        'SINGLE6': undefined,
        'SINGLE7': undefined,
        'SINGLE8': undefined,
        'SINGLE9': undefined,
        'SINGLE10': undefined,
        'SINGLE11': undefined,
        'SINGLE12': undefined,
        'SINGLE13': undefined,
        'SINGLE14': undefined,
        'SINGLE15': undefined,
        'SINGLE16': undefined,
        'SINGLE17': undefined,
        'SINGLE18': undefined,
        'SINGLE19': undefined,
        'SINGLE20': undefined,
        'SINGLE21': undefined,
        'SINGLE22': undefined,
        'SINGLE23': undefined,
        'SINGLE24': undefined,
        'SINGLE25': undefined,
        'SINGLE26': undefined,
        'SINGLE27': undefined,
        'SINGLE28': undefined,
        'SINGLE29': undefined,
        'SINGLE30': undefined,
        'SINGLE31': undefined,
        'SINGLE32': undefined,
        'SINGLE33': undefined,
        'SINGLE34': undefined,
        'SINGLE35': undefined,
        'SINGLE36': undefined,
        'SINGLE37': undefined,
        'SIXLINE1': undefined,
        'SIXLINE2': undefined,
        'SIXLINE3': undefined,
        'SIXLINE4': undefined,
        'SIXLINE5': undefined,
        'SIXLINE6': undefined,
        'SIXLINE7': undefined,
        'SIXLINE8': undefined,
        'SIXLINE9': undefined,
        'SIXLINE10': undefined,
        'SIXLINE11': undefined,
        'SPLIT1': undefined,
        'SPLIT2': undefined,
        'SPLIT3': undefined,
        'SPLIT4': undefined,
        'SPLIT5': undefined,
        'SPLIT6': undefined,
        'SPLIT7': undefined,
        'SPLIT8': undefined,
        'SPLIT9': undefined,
        'SPLIT10': undefined,
        'SPLIT11': undefined,
        'SPLIT12': undefined,
        'SPLIT13': undefined,
        'SPLIT14': undefined,
        'SPLIT15': undefined,
        'SPLIT16': undefined,
        'SPLIT17': undefined,
        'SPLIT18': undefined,
        'SPLIT19': undefined,
        'SPLIT20': undefined,
        'SPLIT21': undefined,
        'SPLIT22': undefined,
        'SPLIT23': undefined,
        'SPLIT24': undefined,
        'SPLIT25': undefined,
        'SPLIT26': undefined,
        'SPLIT27': undefined,
        'SPLIT28': undefined,
        'SPLIT29': undefined,
        'SPLIT30': undefined,
        'SPLIT31': undefined,
        'SPLIT32': undefined,
        'SPLIT33': undefined,
        'SPLIT34': undefined,
        'SPLIT35': undefined,
        'SPLIT36': undefined,
        'SPLIT37': undefined,
        'SPLIT38': undefined,
        'SPLIT39': undefined,
        'SPLIT40': undefined,
        'SPLIT41': undefined,
        'SPLIT42': undefined,
        'SPLIT43': undefined,
        'SPLIT44': undefined,
        'SPLIT45': undefined,
        'SPLIT46': undefined,
        'SPLIT47': undefined,
        'SPLIT48': undefined,
        'SPLIT49': undefined,
        'SPLIT50': undefined,
        'SPLIT51': undefined,
        'SPLIT52': undefined,
        'SPLIT53': undefined,
        'SPLIT54': undefined,
        'SPLIT55': undefined,
        'SPLIT56': undefined,
        'SPLIT57': undefined,
        'SPLIT58': undefined,
        'SPLIT59': undefined,
        'SPLIT60': undefined,
        'STREET1': undefined,
        'STREET2': undefined,
        'STREET3': undefined,
        'STREET4': undefined,
        'STREET5': undefined,
        'STREET6': undefined,
        'STREET7': undefined,
        'STREET8': undefined,
        'STREET9': undefined,
        'STREET10': undefined,
        'STREET11': undefined,
        'STREET12': undefined,
        'STREET13': undefined,
        'STREET14': undefined,
        'ZEROSPIEL': undefined,
        'REDSPLIT': undefined,
        'BLACKSPLIT': undefined,
        'SNAKE': undefined,
        'REDSPLIT_9_12': undefined,
        'REDSPLIT_16_19': undefined,
        'REDSPLIT_18_21': undefined,
        'REDSPLIT_27_30': undefined,
        'BLACKSPLIT_8_11': undefined,
        'BLACKSPLIT_10_11': undefined,
        'BLACKSPLIT_10_13': undefined,
        'BLACKSPLIT_17_20': undefined,
        'BLACKSPLIT_26_29': undefined,
        'BLACKSPLIT_28_29': undefined,
        'BLACKSPLIT_28_31': undefined,
        'ZEROSPIEL_0_3': undefined,
        'ZEROSPIEL_12_15': undefined,
        'ZEROSPIEL_32_35': undefined,
        'ZEROSPIEL_26': undefined,
        'TIERS_5_8': undefined,
        'TIERS_10_11': undefined,
        'TIERS_13_16': undefined,
        'TIERS_23_24': undefined,
        'TIERS_27_30': undefined,
        'TIERS_33_36': undefined,
        'ORPHELINS_6_9': undefined,
        'ORPHELINS_14_17': undefined,
        'ORPHELINS_17_20': undefined,
        'ORPHELINS_31_34': undefined,
        'ORPHELINS_1': undefined,
        'VOISINS_25_26_28_29': undefined,
        'VOISINS_0_2_3': undefined,
        'VOISINS_4_7': undefined,
        'VOISINS_12_15': undefined,
        'VOISINS_18_21': undefined,
        'VOISINS_19_22': undefined,
        'VOISINS_32_35': undefined,
      }
    });
  }

  // prepare data
  createTicket = async(skipTimeout = false, isFutureBet = false) => {
    // console.log('CREATE TICKET CALL', skipTimeout, isFutureBet);
    const PRINT_TICKET_BLOCK_TIMER = 3000;
    const now = Date.now();
    if (!skipTimeout && (now - this.lastCreateTimeRef.current < PRINT_TICKET_BLOCK_TIMER)) {
      return;
    }
    this.lastCreateTimeRef.current = now;
    this.isRepeatedBetRef.current = isFutureBet;

    const curTimer = this.state.timer;
    if (curTimer === 0) {
      return;
    }
    const betsData = this.state.betsMap;
    let bets = {};
    let totalBet = 0;
    for (const [key, value] of Object.entries(betsData)) {
      // console.log(`${key}: ${value}`);
      if (value !== undefined && !isNaN(value)) {
        bets[key] = value;
        totalBet += value;  
      }
    }
    if (totalBet === 0) {
      return;
    }

    // check active shift for current user
    const agentID = this.state.agentID;
    let gameID = this.state.gameID;
    let gameSpinNumber = this.state.gameSpinNumber;
    const bettingShopID = this.state.bettingShopID;

    let checkShiftRes;
    try {
       checkShiftRes = await axios.post(`${API_URL}/checkactiveshift`, {
        bettingShopId: bettingShopID,
        agentId: agentID,
      });
    } catch (e) {
      console.error(e);
    }


    const hasActiveShift = checkShiftRes?.data?.hasActiveShift;
    const isAllowCreate = checkShiftRes?.data?.allowCreateTicket && hasActiveShift;
    if (!isAllowCreate) {
      const msgText = checkShiftRes?.data?.message;
      this.notify(msgText, 'error');
      return;
    }

    if (isFutureBet) {
      // we set game id from
      const fGamesArr = this.futureGamesRef.current;
      const futureBetArrIndex = this.futureBetIndexRef.current;
      if (fGamesArr.length && fGamesArr[futureBetArrIndex + 1]) {
        // update game id each next future bet in array
        gameID = fGamesArr[futureBetArrIndex + 1].gameId;
        gameSpinNumber = fGamesArr[futureBetArrIndex + 1].spinNumber;
      } else {
        console.error('FUTURE GAME ARRAY ERROR');
        return;
      }
    }

    const ticketData = {
      gameID,
      agentID,
      bettingShopID,
      spinNumber: gameSpinNumber,
      bets,
      betAmount: totalBet,
    };
    // console.log('PAYLOAD ticketData', ticketData);
    this.socketServer.emit('create_ticket', ticketData);
    if (isFutureBet) {
      // last future bet in queue 
      if (this.betMultiplierRef.current <= 2 ) {
        this.onClearTable();
        this.clearBetsMap();
      }

      this.futureBetIndexRef.current = this.futureBetIndexRef.current + 1;
      this.betMultiplierRef.current = this.betMultiplierRef.current - 1;

      // this.setState((prevState) => ({
      //   betMultiplier: Math.max(1, (prevState.betMultiplier || 1) - 1),
      // }));
      if (this.betMultiplierRef.current === 1) {
        this.futureBetIndexRef.current = 0;
      }
    } else {
      if (this.betMultiplierRef.current === 1) {
        this.onClearTable();
        this.clearBetsMap();
        this.futureBetIndexRef.current = 0;
      }
    }

  }

  handleTableDataUpdate = (newData) => {
    this.setState({ ...newData });
  };

      // Function to clear all bets
  handleClearClick = () => {
    // setBets([0, 0, 0, 0, 0, 0]);
  }

  calculateBetsTotal = (betsMap) => {
    const initialValue = 0;
    const betsTotal = Object.values(betsMap).reduce(
      (accumulator, currentValue) => accumulator + (!currentValue ? 0 : currentValue),
      initialValue,
    );
    return betsTotal;
  }


formatStringWithHyphens(input) {
  // Ensure the input is a string and has exactly 12 characters
  if (typeof input !== 'string' || input.length !== 12) {
      return '-';
  }
  // Insert a hyphen after every 4 characters
  return input.match(/.{1,4}/g).join('-');
}

hexToDecimal(hex) {
  // Parse the hexadecimal string into a decimal number
  // const decimal = BigInt(`0x${hex}`);
  // return decimal.toString(); // Convert BigInt to string for precise formatting
  // return parseInt(hex, 16);

  return _16To10(hex);
}


generatePDF = (ticketData = {}, bettingShop = '') => {

  // generate pdf content
  // bind spin number from response
  const rawTicketId = ticketData.nanoId;
  const ticketId = this.formatStringWithHyphens(rawTicketId);
  // const hexDTicketId = this.hexToDecimal(rawTicketId);
  const spinNumber = ticketData.spinNumber || '';

  const validationCode = ticketData.validationCode;
  const DAY_MINS = 60 * 24;
  const voidAfter = (parseInt(ticketData.voidAfter) / DAY_MINS).toString();


  const sideBetsMap = {
    'BLACK' : 'BLACK',
    'RED' : 'RED',
    'ODD' : 'ODD',
    'EVEN' : 'EVEN',
    'LOW' : '1-18',
    'HIGH' : '19-36',
    'DOZEN1' : '1-12',
    'DOZEN2' : '13-24',
    'DOZEN3' : '25-36',
    'COLUMN1' : 'Column 1',
    'COLUMN2' : 'Column 2',
    'COLUMN3' : 'Column 3',
    'ZEROSPIEL' : 'Zero Spiel',
    'ORPHELINS' : 'Orphelins',
    'VOISINS' : 'Voisins',
    'SNAKE' : 'Snake',
    'BLACKSPLIT' : 'Black Split',
    'REDSPLIT' : 'Red Split',
    'REDSPLIT_9_12' : 'Red Split 9,12',
    'REDSPLIT_16_19' : 'Red Split 16,19',
    'REDSPLIT_18_21' : 'Red Split 18,21',
    'REDSPLIT_27_30' : 'Red Split 27,30',
    'BLACKSPLIT_8_11' : 'Black Split 8,11',
    'BLACKSPLIT_10_11' : 'Black Split 10,11',
    'BLACKSPLIT_10_13' : 'Black Split 10,13',
    'BLACKSPLIT_17_20' : 'Black Split 17,20',
    'BLACKSPLIT_26_29' : 'Black Split 26,29',
    'BLACKSPLIT_28_29' : 'Black Split 28,29',
    'BLACKSPLIT_28_31' : 'Black Split 28,31',
    'ZEROSPIEL_0_3' : 'Zero Spiel 0,3',
    'ZEROSPIEL_12_15' : 'Zero Spiel 12,15',
    'ZEROSPIEL_32_35' : 'Zero Spiel 32,35',
    'ZEROSPIEL_26' : 'Zero Spiel 26',
    'TIERS_5_8' : 'Tiers 5,8',
    'TIERS_10_11' : 'Tiers 10,11',
    'TIERS_13_16' : 'Tiers 13,16',
    'TIERS_23_24' : 'Tiers 23,24',
    'TIERS_27_30' : 'Tiers 27,30',
    'TIERS_33_36' : 'Tiers 33,36',
    'ORPHELINS_6_9' : 'Orphelins 6,9',
    'ORPHELINS_14_17' : 'Orphelins 14,17',
    'ORPHELINS_17_20' : 'Orphelins 17,20',
    'ORPHELINS_31_34' : 'Orphelins 31,34',
    'ORPHELINS_1' : 'Orphelins 1',
    'VOISINS_25_26_28_29' : 'Voisins 25,26,28,29',
    'VOISINS_0_2_3' : 'Voisins 0,2,3',
    'VOISINS_4_7' : 'Voisins 4,7',
    'VOISINS_12_15' : 'Voisins 12,15',
    'VOISINS_18_21' : 'Voisins 18,21',
    'VOISINS_19_22' : 'Voisins 19,22',
    'VOISINS_32_35' : 'Voisins 32,35',
  };

  // let tableRowsLenght = tableRows.length * 0.293;
  let tableRows = [];

  tableRows = (
    ticketData?.bets ? Object.entries(ticketData.bets) : []
  )
    .filter(([key, value]) => value !== undefined) // Include only placed bets
    .map(([key, value]) => {
      let formKey;
      if (sideBetsMap[key]) {
        formKey = sideBetsMap[key];
      } else if (betmap[key]) {
        formKey = betmap[key].numbers?.join(',');
      } else {
        formKey = key;
      }
      const potentialPayout = ticketData.potentialPayouts?.[key] !== undefined
        ? parseFloat(ticketData.potentialPayouts[key]).toFixed()
        : null; // Include payout if available
      return [formKey, Math.round(value).toFixed(), potentialPayout];
    });



  if(ticketData.megaJackpotId) {
    tableRows.unshift(['MEGA', '-', ticketData.megaJackpotAmount])
    ticketData.payoutAmount = parseInt(ticketData.payoutAmount) || 0;
    ticketData.payoutAmount += parseInt(ticketData.megaJackpotAmount, 10);
  }

  if(ticketData.miniJackpotId) {
    tableRows.unshift(['MINI', '-', ticketData.miniJackpotAmount])
    ticketData.payoutAmount = parseInt(ticketData.payoutAmount) || 0;
    ticketData.payoutAmount += parseInt(ticketData.miniJackpotAmount, 10);
  }

  let tableRowsLength = tableRows.length * 0.293;


  let heightTable = 0;
  let height = 6.29; // Default height for the document
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'in',
    format: [3.12, tableRowsLength + 5.8] // Initial height, will recalculate later
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();


  // Set font and size
  doc.setFontSize(13);
  doc.setFont('helvetica', 'bold');

  // Text to center
  const text = "ROULETTE";
    // Get page width and text width
  const textWidth = doc.getTextWidth(text);

  // Calculate the x position to center the text
  const x = (pageWidth - textWidth) / 2;

  // Add text
  doc.text(text, x, 0.3);

  const text1 = bettingShop || '';
  const textWidth1 = doc.getTextWidth(text1);
  const x1 = (pageWidth - textWidth1) / 2;

  doc.setFontSize(12);  
  doc.setFont('helvetica', 'bold');  
  doc.setTextColor(0, 0, 0);
  doc.text(text1, x1, 0.6);  

  doc.setFontSize(14);  
  doc.setFont('helvetica', 'bold');  
  doc.setTextColor(0, 0, 0);
  doc.text("* * * * * * * * * * * * * * * * * * * * *", 0.25, 0.9);  

  const text2 = "TICKET";
  const textWidth2 = doc.getTextWidth(text2);
  doc.setFontSize(9);  
  doc.setFont('helvetica', 'bold');  
  doc.setTextColor(0, 0, 0);
  doc.text(text2, 0.25, 1.1);  

  doc.setFontSize(9);  
  doc.setFont('helvetica', 'bold');  
  doc.setTextColor(0, 0, 0);
  doc.text(`${ticketId}`, textWidth2 + 0.05, 1.1);  

  const text3 = "DRAW";
  const textWidth3 = doc.getTextWidth(text3);
  doc.setFontSize(9);  
  doc.setFont('helvetica', 'bold');  
  doc.setTextColor(0, 0, 0);
  doc.text(text3, 0.25, 1.4);  
  
  doc.setFontSize(9);  
  doc.setFont('helvetica', 'bold');  
  doc.setTextColor(0, 0, 0);
  doc.text(`#${spinNumber}`, 0.3 + textWidth3, 1.4); 


  const currentDate = new Date(ticketData.createdAt);
  const formattedDate = currentDate.toLocaleString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });

  const date = formattedDate;
  doc.setFontSize(9);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 0);
  doc.text(date, 1.3, 1.4); 

  doc.setFontSize(14);  
  doc.setFont('helvetica', 'bold');  
  doc.setTextColor(0, 0, 0);
  doc.text("* * * * * * * * * * * * * * * * * * * * *", 0.25, 1.75);  


  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 0);
  doc.text("Bet", 0.25, 1.9);

  const rightMargin = 0.25;
  const pageWidth2 = doc.internal.pageSize.width;

  const textX = pageWidth2 - rightMargin;

  doc.setFontSize(9);
  doc.text("Amount", 2.4, 1.9, { align: 'right' }); 
  doc.text("Potential", 3.0, 1.9, { align: 'right' });  

  const columnStyles = {
    0: { halign: 'left', fillColor: [255, 255, 255] }, 
  };

  columnStyles[0] = { halign: 'left', cellWidth: 1.7, fillColor: [255, 255, 255] };
  columnStyles[1] = { halign: 'right',  fillColor: [255, 255, 255] };
  columnStyles[2] = { halign: 'right',  fillColor: [255, 255, 255] };


  doc.autoTable({ 
    body: tableRows,
    startY: 2,
    tableWidth: 2.7,
    margin: { left: 0.2 },
    styles: {
      fontSize: 9,
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontStyle: 'bold', 
    },
    columnStyles, 
    didDrawPage: function (data) {

      heightTable = data.cursor.y - 1.9; 
      console.log("Table Height:", heightTable);
    },
  });

  doc.setFontSize(14);  
  doc.setFont('helvetica', 'bold');  
  doc.setTextColor(0, 0, 0);
  doc.text("* * * * * * * * * * * * * * * * * * * * *", 0.25, heightTable + 2.2);  

  doc.setFontSize(10);  
  doc.setFont('helvetica', 'bold');  
  doc.setTextColor(0, 0, 0);
  doc.text("TOTAL", 0.25, heightTable + 2.4); 


  let payoutAmountFormatted = null;
  if (ticketData?.payoutAmount) {
    payoutAmountFormatted = Math.round(ticketData.potentialPayoutAmount).toFixed();
  }

  const totalBet = `${parseInt(ticketData.betAmount).toFixed()}`;
  const totalPayouts = `${payoutAmountFormatted}`;

  // Set the font properties
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 0);

  // Add text, aligned to the right
  doc.text(totalBet, 2.4, heightTable + 2.4, { align: 'right' });
  doc.text(totalPayouts, 2.9, heightTable + 2.4, { align: 'right' });


  // const totalBet = `$${this.state.betsTotal.toFixed(2)}`;


  doc.setFontSize(14);  
  doc.setFont('helvetica', 'bold');  
  doc.setTextColor(0, 0, 0);
  doc.text("* * * * * * * * * * * * * * * * * * * * *", 0.25, heightTable + 2.7);  

  const canvas = document.createElement('canvas');
  bwipjs.toCanvas(canvas, {
    bcid: 'code128',       // Barcode type
    text: rawTicketId,     // Text to encode
    scale: 5,              // Scale factor
    rotate: 'N',
    height: 1,            // Height of the barcode
    width: 3,
    includetext: false,     // Include text below the barcode
  });

  const barcodeImage = canvas.toDataURL();

  const BARCODE_OFFSET = 2.9;

  // Add the rotated barcode image to the PDF
  doc.addImage(barcodeImage, 'PNG', 0.05, heightTable + BARCODE_OFFSET, 3, 1);


  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');


  const textBefore = "Validation Code ";
  const number = validationCode;
  const textAfter = "";


  // Calculate the widths of the texts
  const textBeforeWidth = doc.getTextWidth(textBefore) + 0.04;
  const numberWidth = doc.getTextWidth(number);
  const totalTextWidth = textBeforeWidth + numberWidth + doc.getTextWidth(textAfter);

  const xStart = (pageWidth - totalTextWidth) / 2; // Center the text on the page

  const BOTTOM_TEXT_OFFSET = 4.2;

  // Draw the text parts
  doc.setTextColor(0, 0, 0); // Black
  doc.text(textBefore, xStart, heightTable + BOTTOM_TEXT_OFFSET);

  doc.setTextColor(0, 0, 0); // Red for the number
  doc.text(number, xStart + textBeforeWidth, heightTable + BOTTOM_TEXT_OFFSET);

  doc.setTextColor(0, 0, 0); // Back to black
  doc.text(textAfter, xStart + textBeforeWidth + numberWidth, heightTable + BOTTOM_TEXT_OFFSET);


  const textBefore2 = "Ticket Void after ";
  const number2 = voidAfter;
  const textAfter2 = "days";

  const textBeforeWidth2 = doc.getTextWidth(textBefore) + 0.04;
  const numberWidth2 = doc.getTextWidth(number2);
  const totalTextWidth2 = textBeforeWidth2 + numberWidth2 + doc.getTextWidth(textAfter);

  

  const xStart2 = xStart - 0.2;
  const BOTTOM_TEXT_OFFSET2 = 4.4;

  // Draw the text parts
  doc.setTextColor(0, 0, 0); // Black
  doc.text(textBefore2, xStart2, heightTable + BOTTOM_TEXT_OFFSET2);

  doc.setTextColor(0, 0, 0); // Red for the number
  doc.text(number2, xStart2 + totalTextWidth2, heightTable + BOTTOM_TEXT_OFFSET2);

  doc.setTextColor(0, 0, 0); // Back to black
  doc.text(textAfter2, xStart2 + totalTextWidth2 + numberWidth, heightTable + BOTTOM_TEXT_OFFSET2);




  doc.setFontSize(12);  
  doc.setFont('helvetica', 'bold'); 
  const text4 = "THANK YOU";
  const textWidth4 = doc.getTextWidth(text4);
  const x4 = (pageWidth - textWidth4) / 2;
  doc.setTextColor(0, 0, 0);
  const THANK_TEXT_OFFSET = 4.72;
  doc.text(text4, x4, heightTable + THANK_TEXT_OFFSET);



  doc.setFontSize(14);  
  doc.setFont('helvetica', 'bold');  
  doc.setTextColor(0, 0, 0);
  doc.text("* * * * * * * * * * * * * * * * * * * * *", 0.25, heightTable + 5.4);  

  // console.log('ticketData.isVoid', ticketData.isVoid, ticketData);
  // ticketData.isVoid = true;

  // check isVoid
  if (ticketData.isVoid) {
    doc.saveGraphicsState();

    doc.setFont("helvetica", "bold");
    doc.setFontSize(48);
    doc.setTextColor(200, 0, 0); // very light gray

    const label = "VOIDED";

    // Center of the page
    const cy = pageHeight / 2 + 1;

    // Convert font size (points) -> your units (inches here)
    const fontSizePt = doc.getFontSize();               // 48 (pt)
    const fontSizeIn = fontSizePt / doc.internal.scaleFactor; // scaleFactor=72 for "in"

    // Shift right by half the rotated text “height” so it looks horizontally centered
    const cx = (pageWidth / 2) + (fontSizeIn / 2) + 1.1;

    doc.text(label, cx, cy, {
      angle: 90,
      align: "center",
      baseline: "middle", // helps if your jsPDF version supports it
    });

    doc.restoreGraphicsState();
  }

  // doc.save(`Ticket_${ticketId}.pdf`);
  // return;
  // Automatically open the print dialog
  // doc.autoPrint();

  // Open the PDF directly in a new browser tab
  const pdfBlob = doc.output("blob");
  const blobURL = URL.createObjectURL(pdfBlob);
  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.top = "0";
  iframe.style.left = "0";
  iframe.style.width = "1px";
  iframe.style.height = "1px";
  iframe.style.border = "none";
  iframe.src = blobURL;

  iframe.onload = () => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print(); // Trigger print directly
  };

  document.body.appendChild(iframe);
  // Clean up the iframe after printing
  const self = this;
  setTimeout(() => {
    document.body.removeChild(iframe);
    self.onClearTable();
    // window.location.reload(false);
  }, 2000);
};

notify = (text = 'Text', type = 'success') => {
  toast[type](text, {
    position: toast.POSITION.TOP_CENTER,
    autoClose: 5000,
  });
};


isSpinning = (isspinning) => {
  isspinning === true ? this.setState({spinning: true}) : this.setState({spinning: false})
}

//handling losing
userLost = () => {
  //update state for message and losses 
  this.setState({
    message: `No luck this time!`,
    losses: this.state.losses + 1,
  }, () => {
    //creating the object to send to mongodb and putting in callback to make sure the state is updated before sending data to database
   

    //and reseting the game
    this.resetGame();
  });

}

//handling winning

//passing multiplier to calcolate how much our user win
userWin = (multi) => {
  //updating state for message, wins and coins
  this.setState({
    message: `You win ${multi * parseInt(this.state.chip)} coins!`,
    wins: this.state.wins + 1,
    coins: this.state.coins + (multi * parseInt(this.state.chip))
  }, () => {
    //creating the object to send to mongodb and putting in callback to make sure the state is updated before sending data to database
    

    //and reseting the game
    this.resetGame();
  });


}

//reset game function: emtying the array and setting all the chips to invisible state
resetGame = () => {
  this.setState({
    arr: [],
    spinning: false,
    num: "",
    firstRow: firstRow.map(num => {
      num.visible = false;
      return num;
    }),
    firstBorder: firstBorder.map(num => {
      num.visible = false
      return num;
    }),
    secondRow: secondRow.map(num => {
      num.visible = false;
      return num;
    }),
    secondBorder: secondBorder.map(num => {
      num.visible = false;
      return num;
    }),
    thirdRow: thirdRow.map(num => {
      num.visible = false;
      return num;
    }),
    thirdBorder: thirdBorder.map(num => {
      num.visible = false;
      return num;
    }),
    fourthRow: fourthRow.map(num => {
      num.visible = false;
      return num;
    }),
    fifthRow: fifthRow.map(num => {
      num.visible = false;
      return num;
    }),
    columnLeft: columnLeft.map(num => {
      num.visible = false;
      return num;
    }),
    columnRight: columnRight.map(num => {
      num.visible = false;
      return num;
    })
  });
}

//finding out if winning number is in any of the arrays
determineValidBets = (length, element, num, multiplier) => {
  let extArr = [...this.state.extArr];
  let lunghezza = element.length;
  if (lunghezza === length) {
    let filtering = element.filter(isItMyNum => isItMyNum == num);
    if (filtering == num) {
      extArr.push(num);
      this.setState({ extArr });
      this.userWin(multiplier);
      console.log(this.state.extArr);
    }
  }
}

//little different here, checking by name and not the length of the array
determineValidBetsColFive = (name, element, arrName, num, multiplier) => {
  let extArr = [...this.state.extArr];
  if (element === name) {
    let filtered = arrName.filter(item => item == num);
    if (filtered == num) {
      extArr.push(num);
      this.setState({ extArr })
      this.userWin(multiplier)
      console.log(this.state.extArr);
    }
  }
}

//gonna pass this function as props to my Weel.js, so i can update it back with the winning number and determine if user won or loose
updateNum = (num) => {

  this.setState({ num, count: this.state.count + 1 }); //i'm getting number, that's one spin, updating state with this info

  //map the array of bets
  this.state.arr.map(item => {

    if (item === num) { //if it's just a single number
      this.userWin(35); //multiplier is 35, user win a bunch of coins
    }

    //here gonna filter the mini-arrays (borders, columns etc.) and see if winner number is present in any of them

    //if item is not string, means it's an array, so i am going to map it in my determineValidBets function
    if (typeof item !== "string") {

      this.determineValidBets(2, item, num, 17);
      this.determineValidBets(3, item, num, 11);
      this.determineValidBets(4, item, num, 8);
      this.determineValidBets(6, item, num, 5);
      //otherwise it's a string (even, odd etc), so before mapping i have to check if the element name is in my array and then map that element
    } else {
      this.determineValidBetsColFive("Even", item, this.even, num, 1);
      this.determineValidBetsColFive("Odd", item, this.odd, num, 1);
      this.determineValidBetsColFive("Black", item, this.black, num, 1);
      this.determineValidBetsColFive("Red", item, this.red, num, 1);
      this.determineValidBetsColFive("1 to 18", item, this.oneToEighteen, num, 1);
      this.determineValidBetsColFive("19 to 36", item, this.nineteenToThirtySix, num, 1);
      this.determineValidBetsColFive("3rd 12", item, this.thirdTwelves, num, 1);
      this.determineValidBetsColFive("2nd 12", item, this.secondTwelves, num, 1);
      this.determineValidBetsColFive("1st 12", item, this.firstTwelves, num, 1);
      this.determineValidBetsColFive("2:1:1", item, this.twoByOneFirst, num, 2);
      this.determineValidBetsColFive("2:1:2", item, this.twoByOneSecond, num, 2);
      this.determineValidBetsColFive("2:1:3", item, this.twoByOneThird, num, 2);
    }
  });

  //if there is nothing in existing numbers array, means user lost, firing the respective function
  if (this.state.extArr.length === 0) {
    this.userLost();
  }
}

//gonna pass this function as props to my Table.js, so i can update it back
updateArr = (arr) => {
  this.setState({ arr })
}

//gonna pass this function as props to my Table.js, so i can update it back
updateCoins = (coins) => {
  this.setState({ coins })
}

//gonna pass this function as props to my Table.js, so i can update it back
updateRow = (row, val) => {
  this.setState({ [row]: val })
}

// todo: bind with UI and API
updateBet = () => {
  // bet payload example
  // {
  //   'SINGLE1': 100
  //   'EVEN': 10
  // }
}
 




numsSelectionHandler = (num, whichRow) => {

  let nums = this.props.arr.length === 0 ? [] : [...this.props.arr];
  console.log(nums);

  let row = [...this.state[whichRow]];

  let coins;




  if (nums.indexOf(num) >= 0) {
    nums.splice(nums.indexOf(num), 1);
    coins = this.props.coins + this.props.chip;


    let updatedRow = row.map(chip => {
      if (chip.n === num) {
        chip.visible = false;

      }
      return chip;
    });

    this.props.updateRow(whichRow, updatedRow);
    this.setState({ [whichRow]: updatedRow });
  } 

  else {
    coins = this.props.coins - this.props.chip;
    nums.push(num);

 
    let updatedRow = row.map(chip => {
      if (chip.n === num) {
        chip.visible = true;

      }
      return chip;
    });

    this.setState({ [whichRow]: updatedRow });
  }


  this.props.updateCoins(coins);
};


updateBetsInfoTxt = (text) => {
  this.setState({betsInfoTxt: text});
}
handleChipClick = (betKey) => {
 
  const bet = betmap[betKey]; // Fetch bet details from betmap.json
 
  if (!bet) return;
  
  const numberKey = betKey; // bet.numbers[0]; // Get the number associated with the bet
  const denomination = this.state.betDenomination; // Current selected denomination

  // if (denomination <= 0) {
  //   alert("Please select a denomination before placing a bet!");
  //   return;
  // }

  // Update the bets map in the state
  this.setState((prevState) => {
    const updatedBetsMap = { ...prevState.betsMap };

    // Add to existing bet or create new bet
    updatedBetsMap[numberKey] = (updatedBetsMap[numberKey] || 0) + denomination;

    const betsTotal = this.calculateBetsTotal(updatedBetsMap);
   

    // alert(
    //   `Bet Placed!\n` +
    //   `Key: ${betKey}\n` +
    //   `Numbers: ${bet.numbers.join(', ')}\n` +
    //   `Payout: ${bet.payout}\n` +
    //   `Total Bet Amount: ${updatedBetsMap[numberKey]}`
    // );

 
    this.props.onDataUpdate({betsMap: updatedBetsMap});

    return { betsMap: updatedBetsMap, betsTotal: betsTotal };
  });
};


onSetUndo = () => {
  this.onSetDenomination(undefined);
  this.setState({isUndo: true});
}
 

handleMouseLeave = (num, whichRow) => {
  let row = [...this.state[whichRow]];
  let updatedRow = row.map(chip => {
    if (chip.n === num) {
      chip.hover = false;
    }
    return chip;
  });

  this.setState({ [whichRow]: updatedRow });
};

onClearTable = () => {
  this.tableRef.current.setState({betsMap: {}, betsTotal: 0});
  this.setState({betsTotal: 0, betMultiplier: 1});
}

calculateBetsTotal = (betsMap) => {
  const initialValue = 0;
  const betsTotal = Object.values(betsMap).reduce(
    (accumulator, currentValue) => accumulator + (!currentValue ? 0 : currentValue),
    initialValue,
  );
  return betsTotal;
}


onSetDenomination = (denom) => {
  this.setState({ betDenomination: denom, isUndo: false });
};

openTicketPopup = () => {
  this.setState({ isTicketPopupVisible: true });
};

closeTicketPopup = () => {
  this.setState({ isTicketPopupVisible: false, ticketIdInput: "" });
}

openVoidTicketPopup = () => {
  this.setState({ isVoidTicketPopupVisible: true });
};

closeVoidTicketPopup = () => {
  this.setState({ isVoidTicketPopupVisible: false, ticketIdInput: "" });
}

toggleMenu = () => {
  this.setState(prevState => ({ isMenuOpen: !prevState.isMenuOpen }));
};

handleTicketIdChange = (e) => {
  this.setState({ ticketIdInput: e.target.value });
};

handleReadTicket = async() => {
  // Here you can add the logic to handle the red ticket action
  console.log("Read ticket clicked with ID:", this.state.ticketIdInput);

  const nanoTicketId = this.state.ticketIdInput.replace(/-/g, '');

  let ticketsRes = await axios.get(`${API_URL}/ticketpages`, {
    params: {nanoId: nanoTicketId}, // Pass params dynamically
  });
  ticketsRes = ticketsRes?.data?.tickets || [];
  const ticketsArr = (ticketsRes?.length && ticketsRes) || [];

  if (!ticketsArr.length) {
    alert('Invalid Ticket');
    return;
  }

  const lastBet = ticketsArr[0] || {};
  let lastBetsMap;
  const hasOrigBetsMap = lastBet && lastBet.placedBets;

  if (hasOrigBetsMap) {
    lastBetsMap = lastBet?.placedBets || {};
  } else {
    lastBetsMap = lastBet?.bets || {};
  }

  const newBetsAsInt = Object.fromEntries(
    Object.entries(lastBetsMap).map(([key, value]) => [key, parseInt(value, 10)])
  );
  const updatedBetsMap = { ...newBetsAsInt };

  const betsTotal = this.calculateBetsTotal(updatedBetsMap);
  this.tableRef.current.setState({betsMap: updatedBetsMap, betsTotal});

  this.setState({
    betsMap: updatedBetsMap,
    betsTotal,
  });

  this.closeTicketPopup();

  const userId = localStorage.getItem("sun_userId");
  // GET ip address
  const ipRes = await axios.get(this.IP_SERVICE);
  const curIp = (ipRes && ipRes.data && ipRes.data.ip) || 0;

  const metadata = await collectLoginClientInfo({
    includeGeolocation: true,
    geolocationOptions: {
      enableHighAccuracy: false,
      timeout: 2000,
      maximumAge: 300000,
    },
  });

  await axios.post(`${API_URL}/logaction`, {
    action: 'repeat_ticket',
    gameId: this.state.gameID,
    role: 'CASHIER',
    user: userId,
    ticketId: lastBet?._id,
    bettingShopId: this.state.bettingShopID,
    metadata,
    ipAddress: curIp,
  });
};

handleVoidTicket = async() => {
  if (this.state.infoText === 'BETS OFF') {
    this.notify('Ticket not allowed to be voided', 'error');
    return;
  }

  // Here you can add the logic to handle the red ticket action
  console.log("Void ticket clicked with ID:", this.state.ticketIdInput);

  const nanoTicketId = this.state.ticketIdInput.replace(/-/g, '');

  let ticketsRes = await axios.get(`${API_URL}/ticketpages`, {
    params: {nanoId: nanoTicketId}, // Pass params dynamically
  });
  ticketsRes = ticketsRes?.data?.tickets || [];
  const ticketsArr = (ticketsRes?.length && ticketsRes) || [];

  if (!ticketsArr.length) {
    alert('Invalid Ticket');
    return;
  }

  const ticketData = ticketsArr[0] || {};

  // console.log('SCANNED TICKET', ticketData);
  const ticketGameId = ticketData.gameId || '';
  const isCurrentGameTicket = this.state.gameID === ticketGameId;

  let isCurrentGameTimerExpired = false;
  // const SECONDS_THRESHOLD = 15;
  if (isCurrentGameTicket) {
    // const createTime = new Date(ticketData.createdAt).getTime();
    // const ROULETTE_LOOP_TIME = 180;
    const currentTimer = this.state.timer;
    // const nowTime = new Date().getTime();
    // const roundSecondsLeft = ROULETTE_LOOP_TIME - currentTimer;
    isCurrentGameTimerExpired = currentTimer < 1; // roundSecondsLeft > SECONDS_THRESHOLD;

    // const expirationTime = nowTime + roundSecondsLeft;
    // const isTicketCreatedThisRound = (nowTime - currentTimer) <= createTime;
  }

  const futureGamesIds = this.futureGamesRef.current.map(game => game.gameId);
  futureGamesIds.shift();
  const allowVoidTicket = (isCurrentGameTicket && !isCurrentGameTimerExpired) || futureGamesIds.includes(ticketGameId);

  if (allowVoidTicket && !ticketData.isVoid) {
    const response = await axios.put(`${API_URL}/voidticket`, {_id: ticketData._id});
    ticketData.isVoid = true;
    // console.log('ticketData', ticketData);
    this.generatePDF(ticketData, ticketData.bettingShopId?.name);
    this.notify('Ticket voided', 'success');

    const userId = localStorage.getItem("sun_userId");
    // GET ip address
    const ipRes = await axios.get(this.IP_SERVICE);
    const curIp = (ipRes && ipRes.data && ipRes.data.ip) || 0;

    const metadata = await collectLoginClientInfo({
      includeGeolocation: true,
      geolocationOptions: {
        enableHighAccuracy: false,
        timeout: 2000,
        maximumAge: 300000,
      },
    });

    try {
      axios.post(`${API_URL}/logaction`, {
        action: 'void_ticket',
        user: userId,
        role: 'CASHIER',
        ticketId: ticketData?._id,
        gameId: ticketData.gameId,
        bettingShopId: ticketData.bettingShopId?._id,
        ipAddress: curIp,
        metadata,
      });
    } catch (e) {
      console.log(e);
    }

  } else {
    this.notify('Ticket not voided, pass expiry or already voided', 'error');
  }

  this.closeVoidTicketPopup();
};

formatWithMask = (input) => {
  if (!input) {
    return '';
  }
  // Remove all non-alphanumeric characters
  const alphanumeric = input.replace(/[^a-zA-Z0-9]/g, '');

  // Insert hyphens after every 4 characters
  const masked = alphanumeric.match(/.{1,4}/g)?.join('-') || '';

  // Limit to 5 groups of 4 characters (24 characters + 5 hyphens = 29 total)
  return masked.slice(0, 29);
};

  render() { 
    const TIMER_LOOP_TIME = 165;

    const startPercentage = (this.state.timer / TIMER_LOOP_TIME) * 100;
 
    return (
      <>  
      {/* <button onClick={this.notify}>Show Toast</button> */}
        <ToastContainer />
        <div id="pdfViewer"></div>
        {this.state.isTicketPopupVisible && (
          <div className="popup-overlay">
            <div className="popup-content">
              <h3>Repeat Ticket</h3>
              <input
                type="text"
                value={this.formatWithMask(this.state.ticketIdInput)}
                onChange={this.handleTicketIdChange}
                placeholder="Enter ticket ID"
                className="popup-input"
              />
              <div className="popup-buttons">
                <button 
                  className="btn-red" 
                  onClick={this.handleReadTicket}
                  disabled={!this.state.ticketIdInput}
                >
                  Read Ticket
                </button>
                <button 
                  className="btn-cancel-popup" 
                  onClick={this.closeTicketPopup}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
        {this.state.isVoidTicketPopupVisible && (
          <div className="popup-overlay">
            <div className="popup-content">
              <h3>Void Ticket</h3>
              <input
                type="text"
                value={this.formatWithMask(this.state.ticketIdInput)}
                onChange={this.handleTicketIdChange}
                placeholder="Enter ticket ID"
                className="popup-input"
              />
              <div className="popup-buttons">
                <button 
                  className="btn-red red-btn" 
                  onClick={this.handleVoidTicket}
                  disabled={!this.state.ticketIdInput}
                >
                  Void Ticket
                </button>
                <button 
                  className="btn-cancel-popup" 
                  onClick={this.closeVoidTicketPopup}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}        
        <div className="admin-page-wrap">

        <div className={`admin-page-menu ${this.state.isMenuOpen ? 'menu-open' : 'menu-closed'}`}>
          {/* Toggle button */}
          {/* <div className="admin-page-menu__toggle" onClick={this.toggleMenu}>
            <div className="admin-page-menu__toggle-icon">
              <img src={this.state.isMenuOpen ? iconClose : iconOk} alt={this.state.isMenuOpen ? "Close" : "Open"} />
            </div>
          </div> */}

          {/* Menu items - only show when menu is open */}
          {this.state.isMenuOpen && (
            <>
              <div className="admin-page-menu__item" onClick={() => this.props.navigate('/dashboard')}>
                <div className="admin-page-menu__item-icon">
                  <img src={homeIcon} alt="Home" />
                </div>
                <div className="admin-page-menu__item-title">
                  <span>Home</span>
                </div>
              </div>
              <div className="admin-page-menu__item" onClick={() => this.props.navigate('/admin')}>
                <div className="admin-page-menu__item-icon">
                  <img src={createIcon} alt="Create" />
                </div>
                <div className="admin-page-menu__item-title">
                  <span>Create</span>
                </div>
              </div>
              <div className="admin-page-menu__item" onClick={() => this.props.navigate('/validate')}>
                <div className="admin-page-menu__item-icon">
                  <img src={validateIcon} alt="Validate" />
                </div>
                <div className="admin-page-menu__item-title">
                  <span>Validate</span>
                </div>
              </div>
              <div className="admin-page-menu__item" onClick={() => this.props.navigate('/tickethistory')}>
                <div className="admin-page-menu__item-icon">
                  <img src={historyIcon} alt="History" />
                </div>
                <div className="admin-page-menu__item-title">
                  <span>History</span>
                </div>
              </div>
              <div className="admin-page-menu__item" onClick={() => this.props.navigate('/shift-management')}>
                <div className="admin-page-menu__item-icon">
                  <img src={shiftIcon} alt="Shift" />
                </div>
                <div className="admin-page-menu__item-title">
                  <span>Shift</span>
                </div>
              </div>
            </>
          )}
        </div>

        
        <div className={`admin-border-wrap admin-border ${this.state.isMenuOpen ? 'menu-open' : 'menu-closed'}`}>
          <div className="admin-border__top">
            <div className="admin-border__left">
              <div className="draws-panel">
                <div className="draws-panel__history">
                  {(this.state.betsLogL || []).slice(-10).reverse().map((item) => {
                    const num = String(item.number);
                    const chipClass = num === '0' ? 'draws-panel__chip--green' : (this.red && this.red.includes(num) ? 'draws-panel__chip--red' : 'draws-panel__chip--black');
                    return (
                      <div key={item.spinId} className="draws-panel__row">
                        <span className="draws-panel__spin">{item.spinId}</span>
                        <span className={`draws-panel__chip ${chipClass}`}>{item.number}</span>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* <div className="betsOf">
                <div className="betsOf__title">BETS {(this.state.timer===0?'OFF':'ON')}</div>
                  <div className="betsOf__table betsOf__table-border">
                    <div className="betsOf__table-table">
                      <table>
                        <tr>
                          <td>TYPE</td>
                          <td>:</td>
                          <td>1ST 12</td>
                        </tr>
                        <tr>
                          <td>NUMBER(S)</td>
                          <td>:</td>
                          <td>1-12</td>
                        </tr>
                        <tr>
                          <td>PAYOUT</td>
                          <td>:</td>
                          <td>2:1</td>
                        </tr>
                        <tr>
                          <td>CURRENT BET	</td>
                          <td>:</td>
                          <td>0</td>
                        </tr>
                      </table>
                    </div>
                  </div>
              </div> */}
            </div>
            
              <div className="admin-border__right">
                <RouletteTable
                  ref={this.tableRef} 
                  onDataUpdate={this.handleTableDataUpdate}
                  betDenomination={this.state.betDenomination} 
                  betsTotal={this.state.betsTotal}
                  onSetDenomination={this.onSetDenomination}
                  //ROWS//
                  firstRow={this.state.firstRow}
                  firstBorder={this.state.firstBorder}
                  secondRow={this.state.secondRow}
                  secondBorder={this.state.secondBorder}
                  thirdRow={this.state.thirdRow}
                  thirdBorder={this.state.thirdBorder}
                  fourthRow={this.state.fourthRow}
                  fifthRow={this.state.fifthRow}
                  columnLeft={this.state.columnLeft}
                  columnRight={this.state.columnRight}
                  //END ROWS//
                  updateRow={this.updateRow}
                  updateArr={this.updateArr}
                  updateCoins={this.updateCoins}
                  num={this.state.num}
                  arr={this.state.arr}
                  count={this.state.count}
                  coins={this.state.coins}
                  chip={this.state.chip}
                  spinning={this.state.spinning}
                />
                {/* <div className="admin-border__bottom">
                  <div className="admin-border__jackpot">
                    <div className="jackpot__title">CURRENT JACKPOT</div>
                    <div className="jackpot__number">$11,403</div>
                  </div>
                </div> */}
              </div>

              <div className="admin-border__bottom-right-wrap">
                <div className="btn-bord btn-print" onClick={() => this.createTicket()}>
                  <div className="btn-bord__icon">
                    <img src={iconOk} alt="" />
                  </div>
                  <span className="btn-bord__text">PRINT TICKET</span>
                </div>
                <div className="btn-bord btn-reprint" onClick={() => this.reprintTicket()}>
                  <div className="btn-bord__icon">
                    <img src={iconReprint} alt="" />
                  </div>
                  <span className="btn-bord__text">REPRINT TICKET</span>
                </div>
                <div className="btn-bord btn-void" onClick={() => this.openVoidTicketPopup()}>
                  <div className="btn-bord__icon">
                    <img src={iconVoid} alt="" />
                  </div>
                  <span className="btn-bord__text">VOID TICKET</span>
                </div>
                <div className="btn-bord btn-clearr" onClick={() => this.openTicketPopup()}>
                  <div className="btn-bord__icon">
                    <img src={iconReceipt} alt="" />
                  </div>
                  <span className="btn-bord__text">REPEAT TICKET</span>
                </div>
                <div className="btn-bord btn-repeatbet" onClick={() => this.repeatBet()}>
                  <div className="btn-bord__icon">
                    <img src={iconRepeatBet} alt="" />
                  </div>
                  <span className="btn-bord__text">REPEAT BET</span>
                </div>
                <div className="btn-bord btn-reset" onClick={() => this.onClearTable()}>
                  <div className="btn-bord__icon">
                    <img src={iconReplay} alt="" />
                  </div>
                  <span className="btn-bord__text">RESET ALL BETS</span>
                </div>
              </div>
              
            </div>


            <div className="admin-border__bottom">
            <div className="admin-border__bottom-right">
 
            <div className="top-info">
              <div className="chip-track">
                {/* <div className="btn-stav-item">
                  <button type="button" className="chip-track__clear" onClick={() => this.onClearTable()} aria-label="Clear">×</button>
                </div> */}
                <div className="btn-stav-item">
                  <button type="button" className={`btn-stav chip-track__clear ${this.state.betDenomination === undefined ? 'active' : ''}`} onClick={() => this.onSetUndo(undefined)} aria-label="Clear">×</button>
                </div>
                <div className="btn-stav-item">
                  <button type="button" className={`btn-stav btn-chipt btn-chipt-yellow ${this.state.betDenomination === 20 ? 'active' : ''}`} onClick={() => this.onSetDenomination(20)}>20</button>
                </div>
                <div className="btn-stav-item">
                  <button type="button" className={`btn-stav btn-chipt btn-chipt-pink ${this.state.betDenomination === 50 ? 'active' : ''}`} onClick={() => this.onSetDenomination(50)}>50</button>
                </div>
                <div className="btn-stav-item">
                  <button type="button" className={`btn-stav btn-chipt btn-chipt-blue ${this.state.betDenomination === 100 ? 'active' : ''}`} onClick={() => this.onSetDenomination(100)}>100</button>
                </div>
                <div className="btn-stav-item">
                  <button type="button" className={`btn-stav btn-chipt btn-chipt-green ${this.state.betDenomination === 500 ? 'active' : ''}`} onClick={() => this.onSetDenomination(500)}>500</button>
                </div>
                <div className="btn-stav-item">
                  <button type="button" className={`btn-stav btn-chipt btn-chipt-purple ${this.state.betDenomination === 1000 ? 'active' : ''}`} onClick={() => this.onSetDenomination(1000)}>1000</button>
                </div>
                <div className="btn-stav-item">
                  <button type="button" className={`btn-stav btn-chipt btn-chipt-black ${this.state.betDenomination === 2000 ? 'active' : ''}`} onClick={() => this.onSetDenomination(2000)}>2000</button>
                </div>
                <div className="btn-stav-item">
                  <button type="button" className={`btn-stav btn-chipt btn-chipt-orange ${this.state.betDenomination === 5000 ? 'active' : ''}`} onClick={() => this.onSetDenomination(5000)}>5000</button>
                </div>
              </div>
            </div>

            <div className="draws-panel__countdown">
              <div className="draws-panel__number">{this.state.timer}</div>
              {/* <div className="draws-panel__timer-icon" /> */}

              <div className="spin-time__icon"> 
              <div class="chart"
                style={{
                  animation: `timer ${this.state.timer}s infinite linear`,
                  background: `conic-gradient(
                    #FCEE21 0 calc(${startPercentage}%),
                    black calc(${startPercentage}%) 100%
                  )`,
                  "--percentage": `${(this.state.timer / TIMER_LOOP_TIME) * 100}%`, // Setting CSS variable for use in styles
                }}
              ></div>
              </div>

              <div className="draws-panel__label">TIMER</div>
            </div>

            {/* <div className="history-blocks">
              {[5, 4, 3, 2, 1, 0].map((i) => {
                const id = (Number(this.state.gameSpinNumber) || 0) - i;
                const d = new Date();
                d.setMinutes(d.getMinutes() - i * 3);
                const timeStr = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }).toLowerCase();
                const isActive = this.state.activeHistoryBlock === i;
                return (
                  <div
                    key={i}
                    className={`history-block ${isActive ? 'history-block--active' : ''}`}
                    onClick={() => this.setState({ activeHistoryBlock: i })}
                  >
                    <div className="history-block__line1">{id > 0 ? id : '—'} | {timeStr}</div>
                    <div className="history-block__line2">${i === 5 ? this.state.betsTotal : 0}</div>
                  </div>
                );
              })}
            </div> */}
            </div>
            <div className="chip-control-panel">
              <div className="chip-control-panel__display">
                <span className="chip-control-panel__amount">${this.state.betsTotal}&nbsp; x &nbsp;{this.betMultiplierRef.current}&nbsp;SPIN(S) = &nbsp;${this.state.betsTotal*this.betMultiplierRef.current}</span>

                {/* <span className="chip-control-panel__amount">{this.betMultiplierRef.current} SPIN(S)</span> */}

                <span className="chip-control-panel__mult">{this.state.gameSpinNumber}&nbsp; - &nbsp;{parseInt(this.state.gameSpinNumber)+this.betMultiplierRef.current-1}</span>

                {/* <span className="chip-control-panel__mult"></span> */}
              </div>
              <div className="chip-control-panel__buttons">
                <button
                  type="button"
                  className="chip-control-panel__btn chip-control-panel__btn--red"
                  onClick={() => {
                    this.betMultiplierRef.current = Math.max(1, (this.betMultiplierRef.current || 1) - 10);
                    // Optional: force re-render if needed
                    this.forceUpdate();
                  }}
                >
                  -10
                </button>

                <button
                  type="button"
                  className="chip-control-panel__btn chip-control-panel__btn--red"
                  onClick={() => {
                    this.betMultiplierRef.current = Math.max(1, (this.betMultiplierRef.current || 1) - 5);
                    this.forceUpdate();
                  }}
                >
                  -5
                </button>

                <button
                  type="button"
                  className="chip-control-panel__btn chip-control-panel__btn--red"
                  onClick={() => {
                    this.betMultiplierRef.current = Math.max(1, (this.betMultiplierRef.current || 1) - 1);
                    this.forceUpdate();
                  }}
                >
                  -1
                </button>

                <button
                  type="button"
                  className="chip-control-panel__btn chip-control-panel__btn--black"
                  onClick={() => {
                    this.betMultiplierRef.current = 1;
                    this.forceUpdate();
                  }}
                >
                  ×
                </button>

                <button
                  type="button"
                  className="chip-control-panel__btn chip-control-panel__btn--green"
                  onClick={() => {
                    const max = this.futureGamesRef.current.length;
                    this.betMultiplierRef.current = Math.min(max, (this.betMultiplierRef.current || 1) + 1);
                    this.forceUpdate();
                  }}
                >
                  +1
                </button>

                <button
                  type="button"
                  className="chip-control-panel__btn chip-control-panel__btn--green"
                  onClick={() => {
                    const max = this.futureGamesRef.current.length;
                    this.betMultiplierRef.current = Math.min(max, (this.betMultiplierRef.current || 1) + 5);
                    this.forceUpdate();
                  }}
                >
                  +5
                </button>

                <button
                  type="button"
                  className="chip-control-panel__btn chip-control-panel__btn--green"
                  onClick={() => {
                    const max = this.futureGamesRef.current.length;
                    this.betMultiplierRef.current = Math.min(max, (this.betMultiplierRef.current || 1) + 10);
                    this.forceUpdate();
                  }}
                >
                  +10
                </button>
              </div>
              {/* <div className="chip-control-panel__display">
                <span className="chip-control-panel__mult">{this.state.gameSpinNumber}&nbsp; - &nbsp;{parseInt(this.state.gameSpinNumber)+this.betMultiplierRef.current-1}</span>
              </div> */}
            </div>

            {/* <div>
                <div className="draws-panel__countdown">
                  <div className="draws-panel__number">{this.state.timer}</div>

                  <div className="spin-time__icon"> 
                  <div class="chart"
                    style={{
                      animation: `timer ${this.state.timer}s infinite linear`,
                      background: `conic-gradient(
                        #FCEE21 0 calc(${startPercentage}%),
                        black calc(${startPercentage}%) 100%
                      )`,
                      "--percentage": `${(this.state.timer / TIMER_LOOP_TIME) * 100}%`, // Setting CSS variable for use in styles
                    }}
                  ></div>
                  </div>

                  <div className="draws-panel__label">TIMER</div>
                </div>
            </div> */}

          </div>
            
          </div> 
          </div>
            
        

          
  

        {/* <div className="wrap-bets"> */}

        

        





        {/* <div className="top-info">
          <div className="info-total">
            <b>
              <span>TOTAL&nbsp;&nbsp;</span>
              <span className="info-total-number">{this.state.betsTotal}</span>
            </b>
          </div>
          <div className="info-right">
            <button className={`btn-stav btn-clear ${this.state.betDenomination === 0 ? 'active' : ''}`} onClick={() => this.onSetDenomination(0)}>Clear</button>
            <button className={`btn-stav ${this.state.betDenomination === 1 ? 'active' : ''}`} onClick={() => this.onSetDenomination(1)}>1</button>
            <button className={`btn-stav ${this.state.betDenomination === 5 ? 'active' : ''}`} onClick={() => this.onSetDenomination(5)}>5</button>
            <button className={`btn-stav ${this.state.betDenomination === 10 ? 'active' : ''}`} onClick={() => this.onSetDenomination(10)}>10</button>
            <button className={`btn-stav ${this.state.betDenomination === 20 ? 'active' : ''}`} onClick={() => this.onSetDenomination(20)}>20</button>
            <button className={`btn-stav ${this.state.betDenomination === 50 ? 'active' : ''}`} onClick={() => this.onSetDenomination(50)}>50</button>
            <button className={`btn-stav ${this.state.betDenomination === 100 ? 'active' : ''}`} onClick={() => this.onSetDenomination(100)}>100</button>
          </div>
        </div> */}

        {/* </div> */}

        

       
        {/* <div className="bottom-info">
          <div className="info-total info-timer">
            <b>
              <span>Spin&nbsp;&nbsp;</span>
              <span className="info-total-number">{this.state.gameSpinNumber}</span>
            </b>
          </div>
          <div className="info-total info-timer">
            <b>
              <span>Timer&nbsp;&nbsp;</span>
              <span className="info-total-number">{this.state.timer}</span>
            </b>
          </div>
          <button disabled={this.state.timer === 0} className="btn-ref" onClick={() => this.createTicket()}>Print Ticket</button>
          <button className="btn-ref">Print Ticket</button>
          <button className="btn-ref">Reprint Ticket</button>
          <button className="btn-ref" onClick={() => this.cancelTicket()}>Cancel Ticket</button>
          <button className="btn-ref" onClick={() => this.cancelTicket()}>Main Menu</button>
          <h4 className='info-text'>{this.state.infoText}</h4>
        </div> */}
      </>
    )
  }
}

export default withNavigation(App);



  //STILL NEED TO CREATE FUNCTIONALITY FOR 

  //Basket, or a five number bet, and allows players to bet on the zero, double zero, 1, 2, and 3. Payout – 6:1.
